function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      strokeWidth: 1.56862748
    },
    d: "M12.549 1.569A3.913 3.913 0 0 0 8.627 5.49v70.588A3.913 3.913 0 0 0 12.55 80h54.902a3.913 3.913 0 0 0 3.922-3.922v-50.98l-21.57-1.96-1.96-21.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.549 0a3.913 3.913 0 0 0-3.922 3.922V74.51a3.913 3.913 0 0 0 3.922 3.921h54.902a3.913 3.913 0 0 0 3.922-3.921V23.53l-21.57-1.961L47.844 0Z",
    style: {
      fill: "#c03630",
      strokeWidth: 1.56862748
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      strokeWidth: 1.56862748
    },
    d: "M47.843 1.569v19.607a3.921 3.921 0 0 0 3.922 3.922h19.608Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.843 0v19.608a3.921 3.921 0 0 0 3.922 3.921h19.608Z",
    style: {
      fill: "#f36961",
      strokeWidth: 1.56862748
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.825 29.117c-.904 0-1.75.443-1.955 1.173-.76 2.801.09 7.133 1.51 12.53l-.429 1.046c-1.086 2.647-2.443 5.284-3.637 7.623-4.928 9.643-8.762 14.846-11.319 15.21l-.01-.105c-.055-1.203 2.164-4.304 5.173-6.77.314-.254 1.653-1.55 1.653-1.55s-1.808.955-2.214 1.201c-3.77 2.25-5.646 4.505-5.952 6.002-.09.444-.032.991.36 1.216l.965.484c2.624 1.314 5.85-2.14 10.14-9.66 4.366-1.431 9.813-2.78 14.772-3.51 4.44 2.536 9.532 3.744 11.488 3.223.372-.099.764-.391.964-.66.157-.248.376-1.239.376-1.239s-.368.501-.671.649c-1.238.584-5.148-.39-9.16-2.353 3.47-.37 6.36-.384 7.903.11 1.962.626 1.963 1.268 1.937 1.398.027-.107.114-.537.104-.72-.045-.471-.19-.891-.545-1.239-.726-.715-2.519-1.076-4.962-1.108-1.841-.02-4.049.141-6.445.484-1.098-.63-2.257-1.324-3.176-2.182-2.329-2.175-4.28-5.195-5.493-8.58.083-.325.162-.642.234-.962.337-1.515.58-6.524.58-6.524s-.96 3.763-1.111 4.33c-.097.36-.217.745-.356 1.144-.735-2.584-1.108-5.088-1.108-6.988 0-.537.046-1.581.198-2.407.074-.59.288-.895.51-1.043.438.106.928.779 1.44 1.903.44.972.413 2.098.413 2.795 0 0 .472-1.725.362-2.745-.066-.612-.649-2.188-1.887-2.169h-.101l-.552-.006zm.421 15.645c1.282 2.577 3.049 5.024 5.367 6.986.517.437 1.067.853 1.633 1.243-4.21.783-8.632 1.885-12.74 3.606a195.7 195.7 0 0 0 2.369-4.308 59.776 59.776 0 0 0 3.371-7.527z",
    style: {
      opacity: 0.2,
      strokeWidth: 1.56862748
    },
    transform: "translate(-6.84 -10.733) scale(1.1944)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      strokeWidth: 1.56862748
    },
    d: "M36.825 27.548c-.904 0-1.75.443-1.955 1.174-.76 2.8.09 7.133 1.51 12.53l-.429 1.045c-1.086 2.647-2.443 5.284-3.637 7.624-4.928 9.643-8.762 14.846-11.319 15.21l-.01-.106c-.055-1.202 2.164-4.304 5.173-6.77.314-.253 1.653-1.549 1.653-1.549s-1.808.954-2.214 1.2c-3.77 2.25-5.646 4.506-5.952 6.002-.09.445-.032.992.36 1.216l.965.485c2.624 1.313 5.85-2.14 10.14-9.66 4.366-1.432 9.813-2.78 14.772-3.51 4.44 2.536 9.532 3.743 11.488 3.222.372-.098.764-.39.964-.66.157-.247.376-1.238.376-1.238s-.368.5-.671.648c-1.238.585-5.148-.39-9.16-2.353 3.47-.37 6.36-.384 7.903.11 1.962.626 1.963 1.268 1.937 1.399.027-.108.114-.538.104-.721-.045-.47-.19-.891-.545-1.239-.726-.715-2.519-1.075-4.962-1.108-1.841-.02-4.049.142-6.445.485-1.098-.631-2.257-1.324-3.176-2.183-2.329-2.175-4.28-5.195-5.493-8.58.083-.325.162-.642.234-.962.337-1.515.58-6.524.58-6.524s-.96 3.763-1.111 4.33c-.097.36-.217.745-.356 1.145-.735-2.584-1.108-5.089-1.108-6.988 0-.537.046-1.582.198-2.408.074-.589.288-.895.51-1.043.438.107.928.779 1.44 1.903.44.973.413 2.098.413 2.795 0 0 .472-1.725.362-2.745-.066-.612-.649-2.187-1.887-2.169h-.101l-.552-.006zm.421 15.646c1.282 2.576 3.049 5.023 5.367 6.986a21.45 21.45 0 0 0 1.633 1.243c-4.21.783-8.632 1.884-12.74 3.605a195.7 195.7 0 0 0 2.369-4.308 59.776 59.776 0 0 0 3.371-7.526z",
    transform: "translate(-6.84 -10.733) scale(1.1944)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#fff",
      strokeWidth: 1.56862748
    },
    d: "M12.549 0a3.913 3.913 0 0 0-3.922 3.922V5.49a3.913 3.913 0 0 1 3.923-3.92h35.294V0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.f1dfccfa9ee6ca80694e59090e8f2278.svg";
export { ForwardRef as ReactComponent };